import { useSiteContent } from '@/__lib/SiteContentProvider';
import { RESERVATION_URL } from '@/content/reservation';
import { strings } from '@/i18n/strings';
import { Button } from '@components/__shared/Button/Button';
import styles from './CtaBand.module.scss';

interface CtaBandProps {
	withSecondary?: boolean;
}

export const CtaBand = ({ withSecondary = true }: CtaBandProps) => {
	const { ctaBand } = useSiteContent().homeContent;

	return (
		<section className={styles.ctaBand}>
			<h2>{ctaBand.headline}</h2>
			<div className={styles.actions}>
				<Button href={RESERVATION_URL} target="_blank" rel="noreferrer">
					{ctaBand.cta.label}
				</Button>
				{withSecondary && (
					<>
						<span className={styles.or}>{strings.ctaBand.or}</span>
						<Button to={ctaBand.secondaryCta.to}>{ctaBand.secondaryCta.label}</Button>
					</>
				)}
			</div>
		</section>
	);
};
